import { HotelLiteModel } from 'api-hooks/hotel';
import { Expose, Type } from 'class-transformer';

export class HotelRoomModel {
  id: string;
  type: string;
  size: string;
  description: string;
}

export class HotelTableModel {
  id: string;

  @Expose({ name: 'check_in' })
  @Type(() => Date)
  checkIn: Date;

  @Expose({ name: 'check_out' })
  @Type(() => Date)
  checkOut: Date;

  night: number;

  @Expose({ name: 'hotel_room' })
  @Type(() => HotelRoomModel)
  hotelRoom: HotelRoomModel;

  @Expose({ name: 'city_tax' })
  cityTax: string;

  description: string;
}

export class HotelTourModel {
  id: string;
  note: string;

  @Type(() => HotelLiteModel)
  hotel: HotelLiteModel;

  @Expose({ name: 'hotel_details' })
  @Type(() => HotelTableModel)
  details: HotelTableModel[];

  @Expose({ name: 'ref_id' })
  refId: string;
}

export class HotelTableMutationInput {
  checkIn: Date;
  checkOut: Date;
  night: number;
  hotelRoomId: string;
  cityTax: number;
  description: string;
}
export class HotelTourMutationInput {
  hotelId: string;
  remark: string;
  details: HotelTableMutationInput[];
}

export class HotelTourUpdateInput {
  tourId: string;
  body: HotelTourMutationInput;
}

export class getHotelTourInput {
  id: string;
}
